import { IsEmbeddable, WebsiteTextData } from 'shared/interfaces/Website';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const websiteBaseEndpoint = '/website';

export const WebsiteService = {
  getSubLinks: async (url: string): Promise<string[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${websiteBaseEndpoint}/sub-links`,
      params: {
        url: url
      }
    });

    return response.data;
  },

  isWebsiteEmbeddable: async (url: string): Promise<boolean> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${websiteBaseEndpoint}/is-embeddable`,
      params: {
        url: url
      }
    });

    const responseData = response.data as IsEmbeddable;
    return responseData.isEmbeddable;
  },

  getWebsiteTextData: async (resourceId: string): Promise<WebsiteTextData> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${websiteBaseEndpoint}/text-data`,
      params: {
        resourceId
      }
    });

    return response.data;
  }
};
